'use strict';

var style = require('./style.js');

var boxShadow = style({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
var shadows = boxShadow;

module.exports = shadows;
